import { parseObj } from '@/utils';
import { getAppChannelValue, EAPP_CHANNEL_VALUE } from './code';

const canUseLocalStorage = typeof localStorage !== undefined;
const canDoumentEl = typeof document !== undefined;

/**
 * [H5] SafeArea config initialization
 *
 * 默认使用 src/styles/index.less 初始化配置
 * 无需额外配置
 */
const initSafeAreaCssVarForH5 = () => {
  // do nothing
};

export const initSafeAreaCssVarForUnionPay = () => {
  initSafeAreaCssVarForH5();
};

const WXMINIAPP_SAFEAREA_STORAGE_KEY = 'WXMINIAPP_SAFEAREA_STORAGE_KEY';

/**
 * [TODO]
 * MiniAppSystemInfo type and cache
 */
export type MiniAppSystemInfoPartOfSafeAreaType = {
  safeArea?: {
    /** 安全区域左上角横坐标 */
    left: number;
    /** 安全区域右下角横坐标 */
    right: number;
    /** 安全区域左上角纵坐标 */
    top: number;
    /** 安全区域右下角纵坐标 */
    bottom: number;
    /** 安全区域的宽度，单位逻辑像素 */
    width: number;
    /** 安全区域的高度，单位逻辑像素 */
    height: number;
  };
  screenWidth?: number;
  screenHeight?: number;
};

export type MiniAppSafeAreaCacheType = {
  /** safe-area-inset-top */
  top: number;
  /** safe-area-inset-left */
  left: number;
  /** safe-area-inset-right */
  right: number;
  /** safe-area-inset-bottom */
  bottom: number;
};

export const getSafeAreaInfoByMiniAppSystemInfo = (
  info?: Partial<MiniAppSystemInfoPartOfSafeAreaType> | null,
): MiniAppSafeAreaCacheType | undefined => {
  if (info && typeof info === 'object' && info.safeArea && info.screenHeight && info?.screenWidth) {
    const { left, right, top, bottom, width, height } = info.safeArea;

    if (left != null && right != null && top != null && bottom != null && width != null && height != null) {
      const _left = left;
      const _right = info.screenWidth - right;
      const _top = bottom - height - top;
      const _bottom = info.screenHeight - bottom;
      if (_left >= 0 && _right >= 0 && _top >= 0 && _bottom >= 0) {
        return {
          left: _left,
          right: _right,
          top: _top,
          bottom: _bottom,
        };
      }
    }
  }
  return undefined;
};

const setSafeAreaValuesForMiniapp = (info?: Partial<MiniAppSystemInfoPartOfSafeAreaType> | null) => {
  if (canUseLocalStorage) {
    if (info && typeof info === 'object' && info.safeArea && info.screenHeight && info?.screenWidth) {
      const _data = getSafeAreaInfoByMiniAppSystemInfo(info);
      localStorage.setItem(WXMINIAPP_SAFEAREA_STORAGE_KEY, JSON.stringify(_data));
    } else {
      console.info(`[setSafeAreaCssVarForMiniapp] error: Invalid values`, info);
    }
  }
};

const getSafeAreaValuesForMiniapp = () => {
  if (canUseLocalStorage) {
    return parseObj<MiniAppSafeAreaCacheType>(localStorage.getItem(WXMINIAPP_SAFEAREA_STORAGE_KEY));
  }
  return undefined;
};

/**
 * [Similar to Weixin MiniApp] SafeArea config initialization
 */
const initSafeAreaCssVarForMiniapp = (info?: Partial<MiniAppSystemInfoPartOfSafeAreaType> | null) => {
  if (info) {
    setSafeAreaValuesForMiniapp(info);
  }
  const safeAreaInfo = getSafeAreaValuesForMiniapp();

  console.info('safeAreaInfo', safeAreaInfo);

  if (safeAreaInfo && canDoumentEl) {
    const { left, right, top, bottom } = safeAreaInfo;
    if (left >= 0 && right >= 0 && top >= 0 && bottom >= 0) {
      document.documentElement.style.setProperty('--safe-area-inset-top', `${top}px`);
      document.documentElement.style.setProperty('--safe-area-inset-right', `${right}px`);
      document.documentElement.style.setProperty('--safe-area-inset-bottom', `${bottom}px`);
      document.documentElement.style.setProperty('--safe-area-inset-left', `${left}px`);
    }
  }
};

export const TIKTOP_SAFEAREA_STORAGE_KEY = WXMINIAPP_SAFEAREA_STORAGE_KEY;

export const initSafeAreaCssVarForTiktop = (info?: Partial<MiniAppSystemInfoPartOfSafeAreaType> | null) => {
  initSafeAreaCssVarForMiniapp(info);
};

export const getSafeAreaValuesForTiktop = () => {
  return getSafeAreaValuesForMiniapp();
};

/**
 *
 * @param info 传递 info value 视为重置数据
 */
export const channelInitSafeAreaCssVar = (info?: Partial<MiniAppSystemInfoPartOfSafeAreaType> | null) => {
  const _channel = getAppChannelValue();

  if (_channel === EAPP_CHANNEL_VALUE.UNIONPAY) {
    initSafeAreaCssVarForUnionPay();
  } else if (_channel === EAPP_CHANNEL_VALUE.DOUYIN) {
    initSafeAreaCssVarForTiktop(info);
  }
};
